<template>
    <div>
        <div class="search-box container">
            <div class="search-box__container">
            <form @submit.prevent="updateSearch" class="form-inline search-box__form" role="form" id="careers-search-form">
                <div class="search-box__header" @click="showOptions = !showOptions">
                    <h2 class="search-box__header--title">Refine your search</h2>
                    <img src="/images/used/filters-arrow.svg" class="search-box__filters-section-arrow" :class="{ 'search-box__filters-section-arrow--open': showOptions }" />
                </div>
                <div v-if="showOptions" class="row">
                    <div class="search-box__container--inner">
                        <div class="search-box__container--inner--search_group">
                            <div class="form-group">
                                <label class="search-box__container--inner--label" for="location">Location</label>
                                <input v-model="search.location" id="searchTextField" class="form-control" placeholder="Enter Town/Postcode" />
                                <small id="invalid-place-message" style="display: none">Please select a location from the dropdown</small>
                            </div>
                            <div class="form-group">
                                <label class="search-box__container--inner--label" for="location">Distance</label>
                                <select @change="fetchResults" v-model="search.distance" class="form-control" placeholder="Select Distance">
                                    <option value="">Select Distance</option>
                                    <option v-for="(distance, value) in distances_data" :key="distance" :value="distance">{{ distance }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label class="search-box__container--inner--label" >Contract Type</label>
                                <select @change="fetchResults" v-model="search.employment_type" class="form-control" placeholder="Contract Type">
                                    <option value="">Select Contract Type</option>
                                    <option v-for="(title, value) in contractTypes" :key="value" :value="value">{{ title }}</option>
                                </select>
                            </div>

                            <div class="form-group">
                            <label class="search-box__container--inner--label" for="keyword">Keyword</label>
                            <input v-model="search.keyword" id="keyword" class="form-control" placeholder="Enter Keyword" />
                            </div>
                        </div>
                        <div>
                            <label class="search-box__container--inner--label" for="titles">Business area</label>
                            <div class="search-box__business_area">
                                <div v-for="(title, value, index) in business_areas_data" class="search-box__business_area--option">
                                <input @change="updateBusinessAreas" class="redesign-checkbox__input" type="checkbox" v-model="selectedPositions" :id="value + index" :value="value">
                                <label class="redesign-checkbox__label search-box__business_area--label " :for="value + index"><span class="redesign-checkbox__span redesign-checkbox__span--blue"></span>{{ title }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="search-box__container--buttons">
                        <button type="submit" name="action"  class="btn btn--primary btn--has-icon">
                            <img src="/images/homepage/multi-brand/search-icon.png" class="btn__icon" alt="" />
                            <span class="search-box__container--buttons--search--icon">Update search</span>
                        </button>
                        <a class="link link--is-button link--secondary link--centered" @click="resetSearchCriteria">Reset search criteria</a>
                    </div>
                </div>
            </form>
            <div id="paginationScrollTarget"></div>
            </div>
        </div>
        <careers-results
            id="careers-results"
            @fetchResults="fetchResults"
            @scrollToResults="scrollToResults"
            :results="results"
            :paging="paging"
            :result_url="result_url"

            :business_areas="business_areas_data"
            :privacy_policy_url="privacy_policy_url"
            :terms_url="terms_url"
        ></careers-results>
    </div>

</template>

<script>
import CareersResults from '../components/CareersResults.vue'

export default {
    props: [
        'total_data',
        'search_data',
        'business_areas_data',
        'result_url',
        'contract_types_data',
        'titles_data',
        'distances_data',
        'search_url',
        'privacy_policy_url',
        'terms_url',
        ],

    components: {
       CareersResults
    },
    data() {
        return {
            showFilters: false,
            search: {
                business_area:[],
                employment_type: '',
                keyword: '',
                location: '',
                distance: '',
                locationLat: null,
                locationLng: null,
                page: null
            },
            selectedPositions:[],
            showOptions:true,
            results:{},
            position:{},
            titles: {},
            contractTypes:{},
            distances: {},
            paging: {
                last_page: 1,
                current_page: 1
            },
            results_url:null,
            shareOptionsOpen: null,
        };
    },

    mounted(){
        this.search = { ...this.search, ...(this.search_data ?? {}) };

        if (Array.isArray(this.search_data?.business_area)) {
            this.selectedPositions.push(...this.search_data.business_area.flat(2));
        }

        this.results_url = this.search_url ?? this.results_url;
        this.total = this.total_data ?? this.total;
        this.titles = this.titles_data ?? this.titles;
        this.contractTypes = this.contract_types_data ?? this.contractTypes;
        this.fetchResults(parseInt(this.search.page) || 1);
        this.initializeAutocomplete();
    },
    methods:{
        initializeAutocomplete() {
            const options = {
                componentRestrictions: { country: 'uk' },
            };

            const input = document.getElementById('searchTextField');
            const autocomplete = new google.maps.places.Autocomplete(input, options);
            const place = autocomplete.getPlace();

            document.getElementById('invalid-place-message').style.display = 'none';
            this.selected = place;

            google.maps.event.addListener(autocomplete, 'place_changed', () => {
                const place = autocomplete.getPlace();
                document.getElementById('invalid-place-message').style.display = 'none';
                this.search.location = place.formatted_address

                if (typeof place.geometry !== 'undefined') {
                    this.search.locationLat = place.geometry.location.lat();
                    this.search.locationLng = place.geometry.location.lng();
                }
            });
        },
        updateBusinessAreas(){
            if (this.selectedPositions){
                this.search.business_area = this.selectedPositions.flat(2).filter(n => n)
            }

            let page = 1

            this.fetchResults(page);
        },
        resetSearchCriteria(businessArea){
            this.selectedPositions = []

            this.search = {
                business_area:[],
                employment_type: '',
                keyword: '',
                location: '',
                distance: '',
                locationLat: null,
                locationLng: null,
                page: null
            }

            this.fetchResults(null)
        },

        updateSearch(page = 1){
            this.fetchResults(page)
            this.scrollToResults('careers-results')
        },

        scrollToResults(id){
            const yOffset = -30;
            const targetElement = document.getElementById(id);

            if (targetElement) {
                const y = targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({top: y, behavior: 'smooth'});
            }
        },

        fetchResults(page = 1) {
            if (Number.isInteger(page)){
                this.search.page = page
            } else {
                this.search.page = 1
            }

            axios.post(this.search_url, this.search)
                .then(response => {
                    this.results = response.data;
                    this.paging = {
                        last_page: response.data.last_page,
                        current_page: response.data.current_page
                    };

                    if (response.data.current_page != 1) {
                        this.showOptions = false
                    }

                    this.updateQueryParameters();
                })
        },

        updateQueryParameters(){
            const params = new URLSearchParams();

            Object.entries(this.search).forEach(([key, value]) => {
                if (value === null || value === undefined || value === '') {
                    return;
                }

                if (Array.isArray(value)) {
                    value.flat(2).filter(entry => entry !== null && entry !== '')
                        .forEach(entry => params.append(key + '[]', entry));
                    return;
                }

                if (key === 'page' && parseInt(value) === 1) {
                    return;
                }

                params.append(key, value);
            });

            const query = params.toString();
            window.history.replaceState({}, '', query ? `${window.location.pathname}?${query}` : window.location.pathname);
        },
    }
}

</script>

